var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBidMachine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 264,
    viewBox: "0 0 264 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.888 143.168H6.04883V246.008H108.888V143.168Z",
    fill: "#6E7B8D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M263.084 196.068L196.068 129.053L129.053 196.068L196.068 263.083L263.084 196.068Z",
    fill: "#223551"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M225.845 6.04883H163.335C152.198 6.04883 143.17 15.0768 143.17 26.2135V88.7238C143.17 99.8604 152.198 108.888 163.335 108.888H225.845C236.981 108.888 246.01 99.8604 246.01 88.7238V26.2135C246.01 15.0768 236.982 6.04883 225.845 6.04883Z",
    fill: "#FCBE46"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.4691 0C89.2225 0 114.938 25.8162 114.938 57.4692C114.938 89.1222 89.2225 114.938 57.4691 114.938C25.7157 114.938 0 89.1222 0 57.4692C0 25.8162 25.7157 0 57.4691 0Z",
    fill: "#E84039"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBidMachine);
export default __webpack_public_path__ + "static/media/bidMachine.04c0a9171ac16e94bcfa4a8b74ece0f1.svg";
export { ForwardRef as ReactComponent };